import React from "react";
import styles from "../characteristicCustomForm.module.scss";
import { useSelector } from "react-redux";

export const ViewCustomForm = ({ getForm, customFormBuilder }) => {
  const showViewForm = useSelector((state) => state.forms.viewForms);
  const forms = useSelector((state) => state.forms.formDetailsData);

  const viewForm = getForm?.formdata || [];
  const formList = customFormBuilder || [];

  if (!viewForm.length) return null;

  const sectionInfo = forms?.sectionInfo || [];

  const questionMap = new Map(formList.map((q) => [q.id, q]));

  const answerMap = new Map(viewForm.map((a) => [a.id, a]));

  const sections = sectionInfo.map((section) => ({
    name: section.name,
    isMandatory: section.isMandatory,
    questions: section.questionsId
      .map((id) => {
        const question = questionMap.get(id);
        const answer = answerMap.get(id);
        return question && answer ? { question, answer } : null;
      })
      .filter(Boolean),
  }));

  const sectionQuestionIds = new Set(sectionInfo.flatMap((section) => section.questionsId));

  const unSectioned = viewForm
    .filter((item) => !sectionQuestionIds.has(item.id))
    .map((item) => {
      const question = questionMap.get(item.id);
      return question ? { question, answer: item } : null;
    })
    .filter(Boolean);

  const renderValues = (question, item) => {
    const options = item?.options || [];
    const hasViewData = showViewForm?.formdata?.length > 0;

    if (!hasViewData) return "";

    if (options.includes("noneoftheabove")) {
      return <div className={`col-form-label ${styles.content_spec}`}>None of the above</div>;
    }

    if (options.includes("alloftheabove")) {
      return question.options
        ?.filter((opt) => opt.key && opt.key !== "alloftheabove" && opt.key !== "noneoftheabove")
        .map((opt, i) => (
          <div key={i} className={`col-form-label ${styles.content_spec}`}>
            {opt.key !== "other" ? opt.value : item.value}
          </div>
        ));
    }

    if (options.length > 0) {
      return options.map((optVal, i) => {
        const optionData = question.options?.find((f) => f?.key === optVal);
        return (
          <div key={i} className={`col-form-label ${styles.content_spec}`}>
            {optionData?.key !== "other" ? optionData?.value : item.value}
          </div>
        );
      });
    }

    return item.value;
  };

  return (
    <>
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className={`col-12 ${styles.section}`}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTitle}>{section.name}</span>
          </div>

          {section.questions.map(({ question, answer }) => (
            <div className={`col-12 ${styles.col_spec}`} key={question.id}>
              <label className={`col-6 col-form-label ${styles.label_spec}`}>{question.desc}</label>
              <div className="col-5 p-0">{renderValues(question, answer)}</div>
            </div>
          ))}
        </div>
      ))}

      {unSectioned?.length > 0 && <div className={`col-12 ${styles.section}`}>
        {unSectioned.map(({ question, answer }) => (
          <div className={`col-12 ${styles.col_spec}`} key={question.id}>
            <label className={`col-6 col-form-label ${styles.label_spec}`}>{question.desc}</label>
            <div className="col-5 p-0">{renderValues(question, answer)}</div>
          </div>
        ))}
      </div>}
    </>
  );
};
